// extracted by mini-css-extract-plugin
export var avatar = "_s0-3";
export var avatarContainer = "_s0-2";
export var avatarSpacer = "_s0-5";
export var avatarSpacerContainer = "_s0-4";
export var avatarStackContainer = "_s0-1";
export var bubble = "_s0-0";
export var remainderBubble = "_s0-6";